module.exports = __webpack_public_path__ + "img/ferratumbusinessflex@2x.9dae517.png";